import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useStaticContext } from "../../../core";
import { triggerDefaultViewChangeRequest } from "../../../core/containers/Keypad/Common/Keypad.actions";
import { E2EIdentifier } from "../../../core/e2e/E2EIdentifier";
import { desktop } from "../../../ui/_themes/constants";
import { themeColors } from "../../../ui/_themes/constants/colors";
import { IState } from "../../redux";
import { CloseButton } from "../common/CloseButton";
import { DisplayMode, View } from "../../../api/api";
import * as helpers from "../../../ui/_themes/helpers";
import { bottomGradient, topGradient } from "../../../ui/_utils/styleUtils";

export const PaytableDesktop = () => {
  const { language } = useStaticContext();
  const dispatch = useDispatch();

  const paytableContent = useSelector(
    (state: IState) => state.paytable.content
  );

  const view = useSelector((state: IState) => state.view);
  const displayMode = useSelector((state: IState) => state.displayMode);

  const paytableActive =
    displayMode === DisplayMode.DEFAULT && view === View.PAYTABLE;

  const { PaytableTitle: paytableTitle } = language;

  if (!paytableActive) {
    return null;
  }

  const onClose = () => dispatch(triggerDefaultViewChangeRequest());

  return (
    <PaytableWrapperDesktop
      paytableContent={paytableContent}
      paytableTitle={paytableTitle}
      onClose={onClose}
    />
  );
};

const PaytableView = ({
  className,
  paytableContent,
  paytableTitle,
  onClose
}) => {
  return (
    <div className={className} data-e2e-id={E2EIdentifier.PAYTABLE_VIEW}>
      <div>
        <CloseButton onClose={onClose} />
        <div>
          <h1>{paytableTitle}</h1>
          {paytableContent && (
            <section>
              <div dangerouslySetInnerHTML={{ __html: paytableContent }} />
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

const PaytableWrapperDesktop = styled(PaytableView)`
  pointer-events: all;

  position: relative;

  height: 100%;
  width: 100%;
  max-height: 100%;

  background-color: ${helpers.getBackgroundColor("settingsWindow")};

  padding-bottom: ${desktop.keypadWrapper.height};

  &:before {
    background-color: ${themeColors.primaryDark};
    position: fixed;
    content: "";
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    top: 0;
  }

  > div {
    height: 100%;
    width: 100%;

    overflow-y: auto;

    ${topGradient};
    ${bottomGradient};

    &:before,
    &:after {
      position: sticky;
    }
  }

  > div > div {
    background: ${helpers.getBackgroundColor(
      "settingsWindowContent",
      "settingsWindow.content"
    )};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-basis: 100%;
    flex-shrink: 0;

    overflow-y: auto;

    color: ${themeColors.onPrimary};
    text-align: left;
  }

  > div > div > h1 {
    font-size: 1.3em;
    padding: 0;
    margin: 0;
    text-align: center;
    text-transform: uppercase;
  }

  > div > div > section {
    padding: 0 5em;
    margin: 1.8em 0 0;
  }

  > div > ${CloseButton} {
    position: fixed;
    top: 1.4em;
    right: 0.9em;
  }
`;
